module.exports = __webpack_public_path__ + "static/media/conamege.25955f12.jpg";